import ShortcutDisplay from "../../../../src/components/ShortcutDisplay";
import StartingStyleDemo from "../../../../src/components/StartingStyleDemo";
import polystyles from "../../../../assets/images/blogs/startingstyle/polystyles.png";
import chromedevtools1 from "../../../../assets/images/blogs/startingstyle/chromedevtools1.png";
import chromedevtools2 from "../../../../assets/images/blogs/startingstyle/chromedevtools2.png";
import startingstyle1 from "../../../../assets/videos/blogs/startingstyle/startingstyle1.mp4";
import startingstyle2 from "../../../../assets/videos/blogs/startingstyle/startingstyle2.mp4";
import startingstyle3 from "../../../../assets/videos/blogs/startingstyle/startingstyle3.mp4";
import startingstyle4 from "../../../../assets/videos/blogs/startingstyle/startingstyle4.mp4";
import * as React from 'react';
export default {
  ShortcutDisplay,
  StartingStyleDemo,
  polystyles,
  chromedevtools1,
  chromedevtools2,
  startingstyle1,
  startingstyle2,
  startingstyle3,
  startingstyle4,
  React
};